export default {
    namespaced: true,
    chatbot: {
      input_placeholder: 'Ask here'
    }
  };  